import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import './below.css';




import Divider from '@mui/material/Divider';

import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import EmailPreferences from './EmailPreferences';




function Copyright() {
  return (
    <Typography align="center" variant="body2" color="text.secondary">
      {'Copyright © '}
      <Link color="inherit" href="https://jalegends.com/">
        JA Legends Dance
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

export default function Belowbar() {
  const location = useLocation();
  const blendsWithShows = location.pathname.startsWith('/shows');
  const blendsWithPricing = location.pathname === '/pricing';
  const blendsWithCourses = location.pathname === '/courses';
  return (


<div className={`foot${blendsWithShows ? ' foot--shows' : ''}${blendsWithPricing ? ' foot--pricing' : ''}${blendsWithCourses ? ' foot--courses' : ''}`}>


<div className="faroot"> 
             <div className="custom-shape-divider-bottom-1672701660">
    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
        <path d="M892.25 114.72L0 0 0 120 1200 120 1200 0 892.25 114.72z" class="shape-fill"></path>
    </svg>
              </div>

 </div>

    <Box
      sx={{
        
        display: 'flex',
        flexDirection: 'column',
        minHeight: '0vh',
      }}
    >
  



      <CssBaseline />
      
      <Box
      
        component="footer"
        sx={{
          py: 3,
          px: 2,
          mt: 'auto',
          backgroundColor: (theme) => blendsWithShows || blendsWithCourses
            ? '#101517'
            : theme.palette.mode === 'light'
              ? theme.palette.grey[200]
              : theme.palette.grey[800],
        }}
      >

    
        <Container maxWidth="lg">
          <Box className="footer-main">
            <Box className="footer-about">
              <Typography variant="h5" component="p" className="footer-brand">JA LEGENDS <span>DANCE</span></Typography>
              <Typography className="footer-description">Real Dancehall. Real Jamaican culture. Keep learning, find your rhythm, and connect with your dance community.</Typography>
              <Box component="address" className="footer-contact">
                <Link href="mailto:Jalegendsteam@gmail.com">Jalegendsteam@gmail.com</Link>
                <Link href="tel:+18765752866">+1 (876) 575-2866</Link>
              </Box>



          <Stack className="footer-socials" direction="row" spacing={1} divider={<Divider orientation="vertical" flexItem />}>

      <IconButton  color="error"  aria-label="youtube" href="https://www.youtube.com/channel/UCS-S71T9VKiM4zwvgx_aOwQ"    >
      <YouTubeIcon />
      </IconButton>

      <IconButton   color="primary" aria-label="facebook" href="https://www.facebook.com/jalegends"  >
        <FacebookIcon />
      </IconButton>

      <IconButton  color="warning" aria-label="instagram"  href="https://www.instagram.com/jalegends_dancee/"  >
        <InstagramIcon />
      </IconButton>
      
          </Stack>
            </Box>
            <Box component="nav" aria-label="Footer navigation" className="footer-links">
              <Typography variant="overline" component="h2">Explore</Typography>
              <Link component={RouterLink} to="/classes">Dance classes</Link>
              <Link component={RouterLink} to="/instructors">Meet the instructors</Link>
              <Link component={RouterLink} to="/students">Dance community</Link>
              <Link component={RouterLink} to="/shows">Watch shows</Link>
              <Link component={RouterLink} to="/pricing">Membership</Link>
              <Link component={RouterLink} to="/feedback">Share feedback</Link>
            </Box>
            <EmailPreferences compact />
          </Box>
          <Box className="footer-bottom"><Copyright /><Link component={RouterLink} to="/dashboard">Your account & email preferences</Link></Box>


        </Container>
      </Box>
    </Box>

    </div>
  );
}
